import { AssetUpdatedFromInspectionEvent, } from '../event/asset-updated-from-inspection.event';
import { InspectionType } from '../../../../inspection/inspection/domain/inspection.interface';
const assetUpdatedFromInspectionProjections = {
    [AssetUpdatedFromInspectionEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            attributes: { ...state?.attributes, ...payload.attributes },
            treeDReviewed: state?.treeDReviewed || payload.inspectionType === InspectionType.TREE_D,
        };
    },
};
export default assetUpdatedFromInspectionProjections;
//# sourceMappingURL=asset-updated-from-inspection.projection.js.map